import { DataBean } from "../DataBean"

export class BudgetSheetFactory extends DataBean {

    public async getInitialBudgetIDCatalog(year: number, idBudgetType: number, idEmployee: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getInitialBudgetIDCatalog_Number_Number_Number", [year, idBudgetType, idEmployee]);
    }

    public async createInitialBudgetRow(idBudgetIDType: number, budgetIDStr: string, idBudgetSource: number, idBudgetResource: number, value: number, description: string): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "budget.Budget_createInitialBudgetRow_Number_String_Number_Number_Number_String", [idBudgetIDType, budgetIDStr, idBudgetSource, idBudgetResource, value, description]);
    }
    public async createInitialBudgetRowList(idBudgetIDType: number, budgetIDStr: string, idBudgetSource: number, idBudgetResource: number, value: number, description: string,adquisitionItemList:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "budget.Budget_createInitialBudgetRow_Number_String_Number_Number_Number_String_java.util.List", 
            [idBudgetIDType, budgetIDStr, idBudgetSource, idBudgetResource, value, description,adquisitionItemList]);
    }

    public async importInitialBudgetRows(idBudgetIDType: number, filename: string, directory: string, dataStore: string, idBudgetStructure: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.accountant.Movement_importInitialBudgetRows_Number_String_String_String_Number", [idBudgetIDType, filename, directory, dataStore, idBudgetStructure]);
    }

    public async createBudgetRowForReductionToInitialBudget(accountantDate: any, idBudgetType: number, idBudgetResource: number, idBudgetSource: number, budgetIDStr: string, value: number, description: string): Promise<any> {
        return this.getCustomService(
            "QuickDataERPCore",
            "budget.Budget_createBudgetRowForReductionToInitialBudget_java.util.Date_Number_Number_Number_String_Number_String",
            [accountantDate, idBudgetType, idBudgetResource, idBudgetSource, budgetIDStr, value, description]);
    }

    public async createInitialBudgetCatalog(idBudgetType: number, idBudgetIDType: number, year: number, items: any, description: string, idEmployee: number, createPdf: boolean): Promise<any> {
        return this.getCustomService(
            "QuickDataERPCore",
            "com.quickdataerp.bean.accountant.AccountantDocument_createInitialBudgetCatalog_Number_Number_Number_java.util.List_String_Number_Boolean",
            [idBudgetType, idBudgetIDType, year, items, description, idEmployee, createPdf]
        );
    }

}